import { type QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { studentDirectoryKeys } from '../../student-directory/hooks/use-student-directory';
import { housesApi } from '../houses';

export const houseRosterKeys = {
  all: ['admin', 'houses', 'roster'] as const,
};

type SetHouseInput = { id: string; houseId: string | null };

// A placement changes the roster, the house standings (sand-dollar stats), the student form and the student page.
function invalidate(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: houseRosterKeys.all });
  void qc.invalidateQueries({ queryKey: ['admin', 'sand-dollars'] });
  void qc.invalidateQueries({ queryKey: ['students'] });
  void qc.invalidateQueries({ queryKey: studentDirectoryKeys.all });
}

export function useHouseRosterQuery() {
  return useQuery({ queryKey: houseRosterKeys.all, queryFn: housesApi.roster });
}

export function useSetStaffHouseMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, houseId }: SetHouseInput) => housesApi.setStaffHouse(id, houseId),
    onSuccess: () => invalidate(qc),
  });
}

export function useSetStudentHouseMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, houseId }: SetHouseInput) => housesApi.setStudentHouse(id, houseId),
    onSuccess: () => invalidate(qc),
  });
}
